export const TABS = [
  // { label: "Create Project", path: "create-project" },
  { label: "Project Information", path: "project-info" },
  // { label: "Business View", path: "business-view" },
  { label: "Milestones", path: "milestones" },
  { label: "BC Information", path: "bc-information" },
  { label: "Technical Scope", path: "technical-scope" },
  { label: "Planning Strategy", path: "planning-strategy" },
  { label: "Engineering Scope", path: "engineering-scope" },
  { label: "Procurement", path: "procurement" },
  { label: "SHEQ / Sustainability", path: "sheq-sustainability" },
  { label: "Logistics", path: "logistics" },
  { label: "KPI Summary", path: "kpi-summary" },
  { label: "CMO Innovation Forum", path: "cmoinnovationforum" },
];
